export default __webpack_public_path__ + "static/media/m-fsk-03.6ffd2b89.jpg";